export const asyncTimeout = (fn, milliseconds) => new Promise((resolve) => {
  setTimeout(async () => {
    const result = await fn();
    resolve(result);
  }, milliseconds);
});
